import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  version = null

  constructor(  
    private cookieService: CookieService,
    private http: HttpClient){

  }


  checkReload(){
    let my = this
    this.http.get<any>('api/Version/GetVersion').subscribe({
      next: data => {
        console.log('當前版本:',data)

        let version = this.version
        //this.cookieService.get('appVersion');
       
        if(!version || version==""){
          //this.cookieService.set('appVersion', data,365,'/');
          this.version = data
        }else{
          if(version!=data){
            // console.log('try load')
            // this.cookieService.set('appVersion', data,365,'/');
            this.version = data
            location.href = location.href;
          }
        }
       
        
      },
      error: error => {
      }
    });

  }



  



   //取得平台
  getPlatformTypeList(isHaveAll:number=1){

    let menuTypeList = []

    this.http.post<any>('api/Menu/GetMenuType', {
    }).subscribe({
      next: data => {

        data.LIST.forEach(element => {
          //門市共用下拉選單
          var selectItem = new selectData();
          selectItem.value = element.ID;
          selectItem.content = element.Name;
          menuTypeList.push(selectItem);
        });
        
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });

    if(isHaveAll){
      menuTypeList = [{value:0,content : "全部"}].concat(menuTypeList)
    }
    return menuTypeList    
    
  }

  //取得用餐種類
  getOrdTypeList(isHaveAll:number=0){

    let ordTypeList = []
    
    // {value:0,content : "全部"},
    // {value:1,content : "外帶"},
    // {value:2,content : "外送"},
    // {value:3,content : "內用"},
    // { value: 5, content: '自取'},

    this.http.get<any>('api/InfoList/GetORDTypeList').subscribe({
      next: data => {
        
        data.LIST.forEach(element => {
          var selectItem = new selectData();
          selectItem.value = element.ID;
          selectItem.content = element.Name;
          ordTypeList.push(selectItem);
        });

      },
      error: error => {
      }
    })


    if(isHaveAll){
      ordTypeList = [{value:0,content : "全部"}].concat(ordTypeList)
    }
    
    return ordTypeList
    
    
  }

  //取得付款方式
  getPaymentList(isHaveAll:number=0,StoreID:number,fun:any){

    let paymentList = []
    

    this.http.get<any>('api/Payment/GetAllPaymentTypeList?' + 
    `ORG_Store_ID=${StoreID}`
    ).subscribe({
      
      next: data => {
        
        data.LIST.forEach(element => {
          var selectItem = new selectData();
          selectItem.value = element.SYS_PaymentKind_ID;
          selectItem.content = element.PaymentKindName;
          paymentList.push(selectItem);
        });

        if(fun)
          fun()

      },
      error: error => {
      }
    })


    if(isHaveAll){
      paymentList = [{value:0,content : "全部"}].concat(paymentList)
    }
    
    return paymentList
    
    
  }


 




















}



class selectData {
  value: any;
  content: string;
}
